import { useTranslation } from 'libs/i18n'
import { cn } from 'utils/style'

type DayFlagProps = {
	value: boolean
	label: string
}

export const DayFlag = ({ value, label }: DayFlagProps) => {
	const { t } = useTranslation()

	return (
		<span
			role="img"
			aria-label={`${label}: ${value ? t('Yes') : t('No')}`}
			className={cn('font-semibold', value ? 'text-success' : 'text-danger')}>
			{value ? '✓' : '✕'}
		</span>
	)
}
